<template>
    <div
        class="label"
        :class="labelClass">
        {{ name }}
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: Number,
            default: 1,
        }
    },
    computed: {
        labelClass() {
            let color = '';

            if(this.type === 1) {
                color = 'blue';
            } else if(this.type === 2) {
                color = 'green';
            } else if(this.type === 3) {
                color = 'orange';
            } 

            if(color) {
                return `label--${color}`;
            }

            return '';
        },
        name() {
            return this.$store.state.activityTypes[this.type];
        }
    }
};
</script>
